"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var BrowserUserAgent =
/*#__PURE__*/
function () {
  function BrowserUserAgent() {
    (0, _classCallCheck2.default)(this, BrowserUserAgent);
  }

  (0, _createClass2.default)(BrowserUserAgent, null, [{
    key: "is_chrome",
    value: function is_chrome() {
      return navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    }
  }, {
    key: "is_ie",
    value: function is_ie() {
      return navigator.userAgent.toLowerCase().indexOf('msie') > -1;
    }
  }, {
    key: "is_ie11",
    value: function is_ie11() {
      return navigator.userAgent.toLowerCase().indexOf('trident') > -1;
    }
  }, {
    key: "is_firefox",
    value: function is_firefox() {
      return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }
  }, {
    key: "is_safari",
    value: function is_safari() {
      return navigator.userAgent.toLowerCase().indexOf("safari") > -1;
    }
  }, {
    key: "is_opera",
    value: function is_opera() {
      return navigator.userAgent.toLowerCase().indexOf("op") > -1;
    }
  }, {
    key: "is_edge",
    value: function is_edge() {
      return navigator.userAgent.toLowerCase().indexOf("edge") > -1;
    }
  }]);
  return BrowserUserAgent;
}();

var _default = BrowserUserAgent;
exports.default = _default;